/**
 * Two Rebuy widgets behind one set of tabs.
 *
 * Rebuy renders each [data-rebuy-id] where it finds it, so the inactive panel
 * is left in the DOM and only hidden. A widget that Rebuy skipped because its
 * panel was hidden at load is re-initialised the first time that tab is shown,
 * and a resize is fired so any carousel inside it re-measures.
 */
if (!customElements.get('rebuy-tabs')) {
  customElements.define(
    'rebuy-tabs',
    class RebuyTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.tabs.forEach(function (tab) {
          tab.addEventListener('click', this.select.bind(this, tab));
        }, this);

        // The CSS placeholder shows while a widget is still empty; stop it after
        // 10s so a widget Rebuy never fills doesn't shimmer forever.
        setTimeout(this.classList.add.bind(this.classList, 'rebuy-tabs--settled'), 10000);

        // Logged-out visitors can't buy (layout/theme.liquid hides Rebuy's Add to
        // cart for them), so each product gets a login link in its place.
        this.loginUrl = this.dataset.loginUrl;
        if (this.loginUrl) {
          this.addLoginLinks();
          new MutationObserver(this.addLoginLinks.bind(this)).observe(this, { childList: true, subtree: true });
        }
      }

      addLoginLinks() {
        this.querySelectorAll('.rebuy-product-block').forEach(function (block) {
          if (block.querySelector('.rebuy-tabs__login')) return;
          var info = block.querySelector('.rebuy-product-info');
          if (!info) return;
          var link = document.createElement('a');
          link.className = 'rebuy-tabs__login';
          link.href = this.loginUrl;
          link.textContent = 'Login to Purchase';
          info.insertAdjacentElement('afterend', link);
        }, this);
      }

      select(tab) {
        this.tabs.forEach(function (other) {
          other.setAttribute('aria-selected', other === tab ? 'true' : 'false');
        });

        var target = this.querySelector('#' + tab.getAttribute('aria-controls'));
        this.panels.forEach(function (panel) {
          panel.hidden = panel !== target;
        });

        if (target) this.render(target);
      }

      render(panel) {
        var widget = panel.querySelector('[data-rebuy-id]');
        if (!widget || widget.children.length) return;
        if (window.Rebuy && typeof window.Rebuy.init === 'function') window.Rebuy.init();
        window.dispatchEvent(new Event('resize'));
      }
    }
  );
}
